
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { JudgeModel } from '@/models/judge.model';

@Component({})
export default class ChallengerDetailJudge extends Vue {
  @Prop({ required: true }) judge!: JudgeModel;
  show: boolean = false;

  openPublicProfile() {
    const blankPage = this.$router.resolve(`/profile/${this.judge.id}`);
    window.open(blankPage.href, '_blank');
  }
}
